module.exports = "/components/components/languageSelectComponent-01c026.html";